import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { VersionsEditorService, VersionsViewService } from '@app/services/app/versions.service';
import { AppRouterService } from '@app/services/app/router.service';

// import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';
import { TitleService } from '@core/services/title.service';
import { ActivatedRoute } from '@angular/router';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { AppService } from '@app/services/app/app.service';
import { VersionsService } from '@app/services/app/versions.service';
import { AddProjectService } from '@app/services/app/add-project.service';
import { LibraryService } from '@app/services/app/library.service';
// models
import { AccessVersion, AccessVersionStatus } from '@app/models/access';
import * as fromFeedbacksModel from '@core/models/version-feedback';
import { VersionShare, isFeedbackVersionShare, isVersionShareOpen } from '@core/models/version-share.model';


/**
 * NOTICE: after jan 2026 this component is not used anymore, but we keep it 
 * because redirects to the version urls under project router.
 */
@Component({
    selector: 'version-details-version-main',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss']
})
export class VersionsDetailsVersionComponent implements OnInit, OnDestroy {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_ERROR = 2;
    public readonly STATUS_NOT_FOUND= 3;
    public readonly STATUS_NOT_ACCESS_DONE= 4;

    public readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';
    public readonly PLUGIN_SEND_FILES = 'share_transfer';
    public readonly ACCESS_ADD_PROJECT = "access_global_new_request";
    public readonly ACCESS_EDIT_TAGS =  'access_version_edit_labels';
    public readonly ACCESS_CHANGE_STATUS =  'access_version_change_status';

    // for view reminder    
    public readonly VIEW_APPROVAL_REMINDER_NONE = 0;
    public readonly VIEW_APPROVAL_REMINDER_DONE = 1;
    public readonly VIEW_APPROVAL_REMINDER_ERROR = 2;


    public version: Objects.Version = null;
    public project: Objects.Request = null;
    public bcTitle: string = 'ARTWORK v. . . . <small>(# .  .  . )</small>';
    public excludedLabels: Array<Objects.Label> = [];

    public pluginsAccess: Array<string> = [];
    public versionAccess: AccessVersion = null;
    public addProjectAccess: boolean = false;
    public context: string = '';
    public view: number = this.VIEW_APPROVAL_REMINDER_NONE;

    public menu: Array<ThreeDotsMenuItem> = [];
    // optional menu items
    protected menuSendFiles: ThreeDotsMenuItem = {
        title: "Send",
        key: "send-files",
        icon: "send-files",
        order: 1
    };
    protected menuAddProject: ThreeDotsMenuItem = {
        title: "Start New Project",
        key: "add-project",
        icon: "add",
        order: 3
    };
    protected menuSeeOriginalProject: ThreeDotsMenuItem = {
        title: "See Original Project",
        key: "see-project",
        icon: "see-project",
        order: 4
    };
    protected menuEditTags: ThreeDotsMenuItem = {
        title: "Edit Tags",
        key: "edit",
        icon: "edit-tags",
        order: 5
    };
    protected menuReminder: ThreeDotsMenuItem = {
        title: "Send approval reminder",
        key: "send-reminder",
        icon: "approval-reminder",
        order: 6
    };



    public status:number = this.STATUS_LOADING;

    private subs = new Subscription();


    constructor(
        public app: AppService,
        private title: TitleService,
        private librarySrv: LibraryService,
        // private activeRoute: ActivatedRoute,
        private viewVersionsSrv: VersionsViewService,
        // private editorVersionSrv: VersionsEditorService,
        private versionsSrv: VersionsService,
        private AddProjectSrv: AddProjectService,
        private appRouter: AppRouterService
    ) { }

    ngOnInit() {
        // set temporal header title
        this.title.set("Version...");

        // https://youtu.be/ocliZj7ZXb0?t=93
        // jun-2023 not used context so not needed this
        // this.urlSubscriptor = this.activeRoute.queryParams.subscribe((params: any) => {
        //     console.log("query params ===>", params);
        //     if (params.context) {
        //         this.context = params.context;
        //     }
        // });
        // get the version
        this.subs.add(this.viewVersionsSrv.selectVersion().subscribe((version: Objects.Version) =>
        {
            if(version != null ){ 
                this.version = version;
                this.bcTitle = 'ARTWORK v.' + version.version + ' <small>(#' + version.id + ')</small>';
                // get general access grants for the version
                this.getVersionAccess();
            }
            this.initView();
        }));
        // get the project of the version.
        this.subs.add(this.viewVersionsSrv.selectProject().subscribe((projectOrigin: Objects.Request) => {
            this.project = projectOrigin
            if(projectOrigin != null )
                this.updateMenu(this.menuSeeOriginalProject);
            this.initView();
        }));



        // plugins & add project from session to set up menu for the version
        this.subs.add(this.app.getSession().subscribe( (session: any) => {
            this.pluginsAccess = session.options.plugins;
            this.addProjectAccess = session.options.access.hasOwnProperty(this.ACCESS_ADD_PROJECT)? session.options.access[this.ACCESS_ADD_PROJECT] : false;

            this.updateMenu(this.menuSendFiles,this.checkPluginAccess(this.PLUGIN_SEND_FILES));
            this.updateMenu(this.menuAddProject,this.addProjectAccess);

            if(this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK)){
                // @deprecated oct-2026: legacy share feedback bubbles url call, replaced by selectVersionShares
                // this.subs.add(this.viewVersionsSrv.selectFeedbacks().subscribe((feedbacks: Array<fromFeedbacksModel.VersionFeedback>) => {
                //     if(feedbacks != null && feedbacks.some((f:fromFeedbacksModel.VersionFeedback) => (f.status != null && f.status.status_code == fromFeedbacksModel.FeedbackStatusCodeEnum.OPENED_CODE ))){
                //         this.updateMenu(this.menuReminder,this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK));
                //     } else {
                //         this.updateMenu(this.menuReminder,false); // quit version approval reminder when there are no feedbacks (after archive all) <diego@twonas.com>
                //      }
                // }));
                this.subs.add(this.viewVersionsSrv.selectVersionShares().subscribe((allShares: Array<VersionShare>) => {
                    // reminders only apply to approval/feedback requests still waiting for the recipient
                    if(allShares != null && allShares.some((vs: VersionShare) => isFeedbackVersionShare(vs) && isVersionShareOpen(vs))){
                        this.updateMenu(this.menuReminder,this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK));
                    } else {
                        this.updateMenu(this.menuReminder,false); // quit version approval reminder when there are no feedbacks (after archive all) <diego@twonas.com>
                     }
                }));
                //   put here a subscriber 
                // TODO dec-2023 manage how to cehck if shares pending 
                // use CoreVersionShareService to cehck shares statsu for the ones we get
            }
        }));

        this.subs.add(this.viewVersionsSrv.selectError('load_version').subscribe((error: HttpErrorResponse) => {
            this.setError(error)
        }));
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    private initView() {
        if(this.versionAccess == null || this.version == null  || this.project == null)
            return;
        this.setHeaderTitle();
        this.status = this.STATUS_DONE;
    }

    private setHeaderTitle() {
        this.title.set("Version #"+ this.version.id);
    }

    private getVersionAccess(){
        this.subs.add(this.librarySrv.selectVersionStatusAccess(this.version.status.id).subscribe((AccessVS: AccessVersionStatus) => {
            if(AccessVS != null && AccessVS.access.grants && this.status != this.STATUS_NOT_ACCESS_DONE){
                this.versionAccess = AccessVS.access.grants;
                this.updateMenu(this.menuEditTags,this.versionAccess.hasOwnProperty(this.ACCESS_EDIT_TAGS) ? this.versionAccess[this.ACCESS_EDIT_TAGS]: false);
                // console.log(" version access ---->",this.versionAccess);
                this.initView();
            }
        }));
    }

    onMenuClick(key: string) {
        switch(key) {
            case "upload-artwork":
                this.appRouter.navigate('/projects/'+this.project.id+'/versions/add', { queryParams: { links: this.version.labels.map((l: Objects.Label) => l.id).sort().join("-") } });
                break;
            case "add-project":
                if(this.version != null){
                    this.AddProjectSrv.clear();
                    this.appRouter.navigate('/projects/add', { queryParams: { version: this.version.id} });
                }
                break;
            case "see-project":
                this.appRouter.navigate('/projects/'+this.project.id);
    
                break;
            case "send-files":
                if (this.checkPluginAccess(this.PLUGIN_SEND_FILES))
                    this.appRouter.navigate('/p/transfer/'+this.project.id, { queryParams: { version: this.version.id} });
                break;
            case "send-reminder":
                if (this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK))
                    this.versionsSrv.sendFeedbackReminder$([this.version]).subscribe(
                        (data:any) => {
                            console.debug(" REMINDER IS DONEEEE ", data)
                            this.view = this.VIEW_APPROVAL_REMINDER_DONE;
                        },
                        (error:any) => {
                            console.debug(" THIS REMINDER FAILED ", error)
                            this.view = this.VIEW_APPROVAL_REMINDER_ERROR;
                        }
                    );
                break;
                
        }
    }


    onStatusUpdate(status: Objects.Status) {
        this.viewVersionsSrv.setStatus(status);
    }

    onSetLabels(labels: Array<Objects.Label>){
        console.debug(" new labels for version are ===>", labels)
        this.viewVersionsSrv.setLabels(labels);
    }

    onReminderSent(e){
        this.view = this.VIEW_APPROVAL_REMINDER_NONE;
    }

    protected checkPluginAccess(plugin: string){
        return this.pluginsAccess.some((pa) => pa == plugin);
    }

    // this function check either remove or add item. based on subscribed events
    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

    protected setError(error: HttpErrorResponse) {
        if(error == null)
            return;

        switch(error.status) {
            case 500:
                this.status = this.STATUS_ERROR;
                break;
            case 404:
                this.status = this.STATUS_NOT_FOUND;
                break;
            case 206:
                this.status = this.STATUS_NOT_ACCESS_DONE;
                break;
            case 200:
                this.status = this.STATUS_DONE;
                break;
        }
    }


}
